import { Container } from '@plone/components';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import cx from 'classnames';
import config from '@plone/volto/registry';

const FieldImageView = (props) => {
  const { content, metadata, data, editable, className, detached, style } =
    props;
  const contentObject = metadata || content || {};
  const imageField = data?.image || 'image';
  const Image = config.getComponent({ name: 'Image' }).component;

  return (
    <div
      className={cx(
        'block field-image align',
        {
          center: !Boolean(data.align),
          detached,
        },
        data.align,
        className,
      )}
      style={style}
    >
      {contentObject?.[imageField]?.download && (
        // <Container className="details-container">
        //   <div className="field-image">
        //     <ConditionalLink
        //       href={flattenToAppURL(contentObject[imageField].download)}
        //       openLinkInNewTab={true}
        //       condition={!editable}
        //     >
        <figure
          className={cx(
            'figure',
            {
              center: !Boolean(data.align),
              detached,
            },
            data.align,
            {
              // START CUSTOMIZATION
              // 'full-width': data.align === 'full',
              // END CUSTOMIZATION
              large: data.size === 'l',
              medium: data.size === 'm' || !data.size,
              small: data.size === 's',
            },
          )}
        >
          <Image
            item={contentObject}
            imageField={imageField}
            alt={contentObject.image_alternative_text || contentObject.title}
            responsive={true}
            sizes={config.blocks.blocksConfig.image.getSizes(data)}
            loading="lazy"
          />
          {contentObject?.image_caption && (
            <figcaption>{contentObject.image_caption}</figcaption>
          )}
        </figure>
        //     </ConditionalLink>
        //   </div>
        // </Container>
      )}
    </div>
  );
};

export default FieldImageView;
